/**
 * 模块说明：销售折扣
 */
import { Service } from '@/tools'
export class DirectoryBookServer<T extends TOrder.DirectoryBook> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.DirectoryBook}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：查询目录商品列表-分页
   * /api/order/directoryBook/v1/pageDirectoryBook
   */
  pageDirectoryBook = <K extends T['ApiPageDirectoryBook']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPageDirectoryBook', data)
}
